export default "__VITE_ASSET__5K_B_Ck$__"